<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <map-nav-bar :btmList="btmList" />
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
//种植业map
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";

import { getSmartwlMapLdsmmData } from "@/api/njfb";
import { findIndexByName } from "@/util/index";
import { snqyMixin } from "@/util/mixin/snqyMixin";
export default {
  mixins: [snqyMixin],
  data() {
    return {
      curIndex: 0, //当前加载分布类型id
      curName: "", //当前加载分布名称
      nowZoom: 0,
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      hoverArr: [],
      baseList: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [-10, 50],
      baseAnchor: [14, 28],
      mianArr: [],
      nycy: [
        {
          name: "荔枝",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_lz_02/MapServer",
        },
        {
          name: "龙眼",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_ly_01/MapServer",
        },
        {
          name: "香蕉",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_xj_01/MapServer",
        },
      ],
    };
  },
  computed: {
    btmList() {
      let arr = [
        {
          name: "农机",
          pic: require("images/map/nj.png"),
        },
      ];
      let tmparr;
      switch (this.curIndex) {
        case -1:
          break;
        case 0:
          tmparr = [
            {
              name: "面积>40万亩",
              pic: require("images/map/red.jpg"),
            },
            {
              name: "面积>1万亩",
              pic: require("images/map/fs.jpg"),
            },
            {
              name: "面积>1000亩",
              pic: require("images/map/dfs.jpg"),
            },
          ];
          arr = tmparr;
          break;
        case 1:
          tmparr = [
            {
              name: "高州市龙眼现代化农业产业园",
              pic: require("images/map/ry-c1.jpg"),
            },
            {
              name: "面积>1万亩",
              pic: require("images/map/ry-c2.jpg"),
            },
            {
              name: "面积>1000亩",
              pic: require("images/map/ry-c3.jpg"),
            },
          ];
          arr = tmparr;
          break;
        case 2:
          tmparr = [
            {
              name: "香蕉面积>1万亩",
              pic: require("images/map/xj-c1.jpg"),
            },
            {
              name: "香蕉面积>1000亩",
              pic: require("images/map/xj-c2.jpg"),
            },
            {
              name: "三华李面积>1万亩",
              pic: require("images/map/xj-c3.jpg"),
            },
            {
              name: "三华李面积>1000亩",
              pic: require("images/map/xj-c4.jpg"),
            },
            {
              name: "香蕉、三华李面积>1万亩",
              pic: require("images/map/xj-c5.jpg"),
            },
          ];
          arr = tmparr;
          break;
      }
      return arr;
    },
  },
  mounted() {
    this.$bus.$on("zlchange", (val) => {
      let index = findIndexByName(val, this.nycy);
      this.poisiton = {};
      this.curName = val;
      this.curIndex = index;
      if (index > -1) {
        // change map2
        if (this.tileMapUrl === this.$config.tileMapUrlColor) {
          this.initMap(true, true);
        }
        if (this.basesGroup) {
          this.map.removeLayer(this.basesGroup);
        }
        this.changeMap(this.nycy[index]["url"]);
      } else {
        this.removemap2();
        setTimeout(() => {
          if (this.tileMapUrl !== this.$config.tileMapUrlColor) {
            this.initMap(false, true);
          }
          if (val === "农机分布") {
            this.dataLoad();
          } else if (val === "龙头企业") {
            this.snqyDataload(3);
          } else if (val === "合作社") {
            this.snqyDataload(4);
          } else if (val === "家庭农场") {
            this.snqyDataload(5);
          } else if (val === "农资经营企业") {
            this.snqyDataload(6);
          } else if (val === "生产基地") {
            this.snqyDataload(7);
          }
        }, 10);
      }
    });
    this.initMap();
  },
  methods: {
    changeMap(url) {
      // 修改切片图层
      this.removemap2();
      if (url) {
        this.tileMapLayer2 = esri.tiledMapLayer({
          url: url,
        });
        window.map.addLayer(this.tileMapLayer2);
      }
    },
    removemap2() {
      // 删除切片图层
      if (this.tileMapLayer2) {
        this.tileMapLayer2._container.remove();
        this.tileMapLayer2.remove();
        this.tileMapLayer2 = null;
      }
    },
    initMap(iswhite = true, isreload = false) {
      // 加载底图
      this.tileMapUrl = this.$config.tileMapUrl;
      if (!iswhite) {
        this.tileMapUrl = this.$config.tileMapUrlColor;
      }
      if (isreload && this.map) {
        this.map.off("click");
        this.map.remove();
        this.map = null;
        window.map = null;
      }
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998],
        }
      );

      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false,
      });
      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: this.tileMapUrl,
      });
      tileMapLayer.addTo(map);
      this.map.setView(
        L.latLng(this.$config.sLat, this.$config.sLng),
        this.nowZoom
      );
      //   setTimeout(() => {
      // eslint-disable-next-line no-undef
      // $(".leaflet-control-attribution").empty();
      //   }, 300);
      if (this.tileMapUrl === this.$config.tileMapUrl) {
        this.changeMap(this.nycy[this.curIndex]["url"]);
      }
      map.on("click", (e) => {
        console.log(e.latlng);
        this.poisiton = {};
      });
      map.on("zoom", () => {
        this.nowZoom = this.map.getZoom();
        this.poisiton = {};
      });
      map.on("move", () => {
        this.poisiton = {};
      });
    },
    //加载标记点数据
    dataLoad() {
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
        this.baseList = [];
      }
      getSmartwlMapLdsmmData("nj").then((data) => {
        data.map((ele) => {
          ele.latitude = Number(ele.latitude);
          this.baseList.push(ele);
        });
        this.baseLoad();
      });
    },

    //多基地数据加载
    baseLoad() {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      this.baseList.map((it) => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          let pointUrl = require("images/map/nj.png");
          if (it.img) {
            pointUrl = require("images/map/" + it.img);
          }
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names hide'>" +
              it.name +
              "</span></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor,
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          baseLayer.on("click", (e) => {
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "njfbDrawer");
          });
          baseLayer.on("mouseover", (it) => {
            // this.ncCode = it.target.options.attributes.code;
            console.log("it", it.target.options.attributes);
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
    },
  },
  destroyed() {
    this.$bus.$off("zlchange");
  },
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9

    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none

    >>>.leaflet-bottom
        display none

    .ncDetail
        position absolute
    // >>>.my-div-names
    //     background #ffa800
    //     &:before
    //         border-top: solid 10px #ffa800;

    >>>
        .my-div-icon
            color #fff
            // z-index 970 !important

        .indicator-box
            position relative

        .my-div-name
            font-size .08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, .8)
            padding 2px 8px

        .my-div-name:hover
            z-index 999
            font-size .09rem

        .my-div-names.hide
            display none
        .my-div-names
            z-index 999
            font-size .07rem
            color #0F3F76
            position absolute
            top -34px
            left 15px
            width max-content
            padding .01rem .06rem
            border-radius 5px
            background #ffa800
            transform translateX(-50%)
            &:before
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -9px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #ffa800;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
        .my-div-names.lt
            background #FF9000
            &:before
                border-top-color #FF9000
        .nopx-left-btm
            position absolute
            left -120px
            top 17px
        .nopx-left-top
            position absolute
            left: -138px;
            top: -50px;
        .nopx-right-top
            position absolute
            left 14px
            top -19px
        .nopx-right-btm
            position absolute
            left: 14px;
            top: 18px;
        .nopx-right-top-box
            position absolute
            left 144px
            transform: translateY(-50%);
        .nopx-right-btm-box
            position absolute
            left 120px
            bottom -150px
        .nopx-left-top-box
            position absolute
            left -64px
            transform: translateX(-100%);
            top: -178px;
        .nopx-left-btm-box
            position absolute
            left: -105px;
            transform: translateX(-100%);
            bottom: -115px;
        .nopx-pic1
            position absolute
            top -50px
</style>
